import { hot } from 'react-hot-loader/root';
import Component from './tableActions-view';

export default hot(Component);
